module.exports = __webpack_public_path__ + "static/assets/1fde35a1b32876ae5c1b0307eb5a7f1a.png";